let objAttributesInfo = {
  right: false,
  icon: 'info',
  text: 'Lorem ipsum!',
  background: 'primary',
  trigger: 'click',
  attributes: {
    class: 'mr-3 sizeIcone'
  }
};

const objHeaderCard = {
  colorClass: 'primary',
  colorHexa: '#000',
  label: 'Card teste',
  icon: 'forward',
  colorIcon: '#e5e5e5'
};

export default {
  i4proAlert: {
    models: {
      type: 'i4proAlert',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      fill: [],
      filledBy: [],
      attributesAlert: {
        label: 'Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Nullam vel sem. Pellentesque dapibus hendrerit tortor.',
        outlined: true,
        type: 'success',
        prominent: true,
        border: 'left',
        icon: 'thumb_up'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesAlert',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12 mt-2',
        title: 'Attributes Alert'
      }
    ]
  },

  i4proAutocomplete: {
    models: {
      type: 'i4proAutocomplete',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      attributesSelect: {
        label: 'Auto Complete',
        clearable: true,
        appendIcon: 'keyboard_arrow_down',
        color: 'primary',
        dense: true,
        items: []
      },
      searchParams: {
        procedure: 'vue.p_pesquisar_usuario',
        text: 'nm_usuario',
        value: 'id_usuario',
        numberCharactersSearch: 5
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        hidden: '',
        readonly: false,
        filledBy: [],
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        hidden: '',
        readonly: false,
        filledBy: [],
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        hidden: '',
        readonly: false,
        filledBy: [],
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Select'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Attributes Select Items',
        objectRequired: [
          'text',
          'value',
          {
            item1: 'teste'
          }
        ]
      },
      {
        type: 'devContainerOfPanel',
        model: 'searchParams',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Search Params'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proCheckbox: {
    models: {
      type: 'i4proCheckbox',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributes: {
        label: 'Checkbox',
        color: 'primary',
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proCombobox: {
    models: {
      type: 'i4proCombobox',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesSelect: {
        label: 'Combobox',
        itemText: 'text',
        itemValue: 'value',
        clearable: true,
        dense: true,
        items: [
          {
            text: 'opção 1',
            value: '1'
          },
          {
            text: 'opção 2',
            value: '2'
          }
        ]
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Select'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'attributesSelect Items',
        objectRequired: ['text', 'value']
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proDatePickerDialog: {
    models: {
      type: 'i4proDatePickerDialog',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      btnShow: true,
      btnFlat: true,
      btnCancelColor: 'primary',
      btnCancelLabel: 'Cancelar',
      btnSaveColor: 'primary',
      btnSaveLabel: 'Salvar',
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesDialog: {
        transition: 'scale-transition',
        persistent: true,
        width: '290px'
      },
      attributesTextField: {
        label: 'Date Picker Dialog',
        clearable: true,
        placeholder: '',
        prependInnerIcon: 'calendar_today',
        dense: true
      },
      attributesDatePicker: {
        locale: 'pt-br',
        headerColor: 'primary lighten-1'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnShow',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'btnShow',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnFlat',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-12',
        attributes: {
          label: 'btnFlat',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelColor',
        styleClasses: 'my-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnCancelColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnCancelLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveColor',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnSaveColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnSaveLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDialog',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Dialog'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDatePicker',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes DatePicker'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proDatePickerMenu: {
    models: {
      type: 'i4proDatePickerMenu',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      btnShow: false,
      btnFlat: true,
      btnCancelColor: 'primary',
      btnCancelLabel: 'Cancelar',
      btnSaveColor: 'primary',
      btnSaveLabel: 'Salvar',
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesMenu: {
        transition: 'scale-transition',
        minWidth: '290px'
      },
      attributesTextField: {
        clearable: true,
        label: 'Date Picker Menu',
        placeholder: '',
        prependInnerIcon: 'calendar_today',
        dense: true
      },
      attributesDatePicker: {
        locale: 'pt-br'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnShow',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'btnShow',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnFlat',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-12',
        attributes: {
          label: 'btnFlat',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelColor',
        styleClasses: 'my-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnCancelColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnCancelLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveColor',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnSaveColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'btnSaveLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesMenu',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Menu'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDatePicker',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes DatePicker'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proFileInput: {
    models: {
      type: 'i4proFileInput',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      min: 0,
      max: 5,
      fill: [],
      filledBy: [],
      attributesTextField: {
        label: 'File input',
        placeholder: 'Upload your documents',
        prependIcon: 'mdi-paperclip',
        dense: true
      },
      attributesChips: {
        color: 'primary',
        label: true
      },
      attributesFile: {
        card: {
          width: 200,
          dark: true,
          color: 'primary'
        },
        image: {
          height: '225px'
        }
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesChips',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Chips'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesFile.card',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Card'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesFile.image',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Image'
      }
    ]
  },

  i4proFileUploadList: {
    models: {
      type: 'i4proFileUploadList',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      attributes: {
        drop: true,
        multiple: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      }
    ]
  },

  i4proEcm: {
    models: {
      type: 'i4proEcm',
      domain: '1',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      fieldName: '',
      attributesFiles: {
        drop: true,
        multiple: true
      },
      attributes: {
        excludeItem: true,
        title: true
      },
      attributesTable: {
        dense: true,
        itemsPerPage: 5,
        showSelect: true,
        class: 'elevation-1'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12 ',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'domain',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Domain',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesFiles',
        component: 'dev-simple-object-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Files'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTable',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes Table'
      }
    ]
  },

  i4proEcmFile: {
    models: {
      type: 'i4proEcmFile',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      rules: [],
      fill: [],
      visible: true,
      readonly: false,
      ecm: {
        domain: 1,
        id_tp_document: 9
      },
      attributesTextField: {
        label: 'i4proEcmFile',
        placeholder: 'Selecione o Arquivo',
        prependIcon: 'mdi-paperclip'
      },
      attributesChips: {
        color: 'primary',
        label: true
      },
      attributesFile: {
        card: {
          width: 350,
          dark: true,
          color: 'primary'
        },
        image: {
          height: '225px'
        }
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'HasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'ecm',
        component: 'dev-simple-object-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Ecm'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesChips',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Chips'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesFile.card',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Card'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesFile.image',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Image'
      }
    ]
  },

  i4proEcmBanner: {
    models: {
      type: 'i4proEcmBanner',
      model: 'id_ecm_banner',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      fieldName: 'new-id_ecm_banner',
      attributesBanner: {
        hideDelimiters: true,
        continuous: true,
        animationHover: true,
        height: 600
      },
      attributes: {
        items: []
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12 ',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'List',
              value: 'list'
            }
          ]
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Attributes',
        objectRequired: ['id_document', 'nm_key']
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesBanner',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Banner'
      }
    ]
  },

  i4proEcmListDownload: {
    models: {
      type: 'i4proEcmListDownload',
      model: '',
      styleClasses: 'col-6',
      visible: true,
      readonly: false,
      fieldName: '',
      typeLookup: "table",
      procedure: {
        name: ""
      },
      attributes: {
        dense: true,
        showHeader: true
      },
      headers: [],
      itemsTable: []
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12 ',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 pb-3 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'itemsTable',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Items Table',
        objectRequired: ['name', 'id_document', 'nm_key']
      },
      {
        type: 'devContainerOfPanel',
        model: 'headers',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Headers',
        objectRequired: ['text', 'value']
      },
    ]
  },

  i4proGroupButtons: {
    models: {
      type: 'i4proGroupButtons',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      items: [
        {
          label: 'Button',
          id: '',
          name: '',
          actionName: '',
          visible: true,
          readonly: false,
          hasConditions: false,
          params: {
            validate: false
          },
          hiddenByPage: false,
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          attributes: {
            color: 'primary',
            dark: true
          },
          attributesIcon: {
            icon: ''
          }
        }
      ]
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-actions-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Items'
      }
    ]
  },

  i4proLabel: {
    models: {
      type: 'i4proLabel',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      text: 'Label',
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesLabel: {
        class: 'primary--text text-subtitle-1'
      },
      appendIcon: {
        right: true,
        icon: 'access_time',
        attributesIcon: {
          color: 'primary',
          class: ''
        },
        tooltip: {
          text: 'teste 1',
          tooltipColorClass: 'red',
          trigger: 'click'
        }
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'text',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Text',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesLabel',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Label'
      },
      {
        type: 'devAppendIcon',
        model: 'appendIcon',
        styleClasses: 'col-12',
        title: 'Attributes Icon'
      },
      {
        type: 'devTextHint',
        model: 'textHint',
        styleClasses: 'col-12',
        title: 'text Hint'
      }
    ]
  },

  i4proPassword: {
    models: {
      type: 'i4proPassword',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      actionEvent: 'continuar',
      rules: [],
      min: 0,
      max: 50,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesTextField: {
        label: 'Password',
        clearable: true,
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'actionEvent',
        styleClasses: 'my-0 py-0 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'actionEvent',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proRadioGroup: {
    models: {
      type: 'i4proRadioGroup',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesRadioGroup: {
        column: true
      },
      attributesRadio: {
        label: 'Radio Group',
        color: 'info',
        readonly: false,
        dense: true
      },
      attributesSelect: {
        items: [
          {
            text: 'Radio 1',
            value: 1
          },
          {
            text: 'Radio 2',
            value: 2
          }
        ]
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesRadioGroup',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes RadioGroup'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesRadio',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Radio'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Attributes Select Items',
        objectRequired: ['text', 'value']
      }
    ]
  },

  i4proRangeSlider: {
    models: {
      type: 'i4proRangeSlider',
      model: '',
      fieldName: '',
      typeLookup: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      actionEvent: 'continuar',
      rules: [],
      min: 0,
      max: 3,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributes: {
        tickLabels: ['Winter', 'Spring', 'Summer', 'Fall'],
        min: 0,
        max: 3,
        ticks: true,
        tickSize: 4
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'actionEvent',
        styleClasses: 'my-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'actionEvent',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes'
      }
    ]
  },

  i4proRating: {
    models: {
      type: 'i4proRating',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesRating: {
        label: 'Rating',
        color: 'yellow darken-3',
        backgroundColor: 'grey darken-1',
        halfIncrements: true,
        hover: true,
        dense: true,
        small: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        readonly: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'mb-2 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'mb-2 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'mb-2 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesRating',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Rating'
      }
    ]
  },

  i4proSelect: {
    models: {
      type: 'i4proSelect',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      readonly: false,
      visible: true,
      rules: [],
      min: 1,
      max: 3,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesSelect: {
        label: 'Select',
        clearable: true,
        appendIcon: 'zmdi zmdi-chevron-down',
        dense: true,
        items: [
          {
            text: 'opção 1',
            value: '1'
          },
          {
            text: 'opção 2',
            value: '2'
          }
        ]
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Select'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSelect.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Attributes Items',
        objectRequired: ['text', 'value']
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proSlider: {
    models: {
      type: 'i4proSlider',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      min: 1,
      max: 100,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributes: {
        label: 'Slider',
        thumbLabel: 'always',
        min: 0,
        max: 100,
        ticks: 'always',
        step: 10,
        readonly: false,
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        visible: true,
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required', 'min', 'max']
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        readonly: false,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      }
    ]
  },

  i4proSwitch: {
    models: {
      type: 'i4proSwitch',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributes: {
        label: 'Switch',
        color: 'primary',
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      }
    ]
  },

  i4proTextFieldSearch: {
    models: {
      type: 'i4proTextFieldSearch',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      itemText: 'name',
      itemValue: 'id',
      rules: [],
      min: 1,
      max: 50,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesTextField: {
        label: 'Label',
        color: 'primary',
        dense: true,
        clearable: true,
        validateOnBlur: true,
        appendIcon: 'search'
      },
      attributesDialog: {
        buttonColor: 'info',
        buttonLabel: 'Clique aqui',
        cardTolbarColor: 'primary',
        cardTolbarTitle: '',
        fullscreen: false,
        width: 800,
        hideOverlay: false,
        persistent: false,
        scrollable: false,
        transition: 'dialog-bottom-transition',
        actionSpacer: true
      },
      attributesTable: {
        editIcon: 'edit',
        key: '',
        dataTable: {
          caption: '',
          disableFiltering: false,
          disablePagination: false,
          disableSort: false,
          fixedHeader: false,
          singleSelect: true,
          itemsPerPage: 10,
          showSelect: true,
          multiSort: false,
          showExpand: false,
          expandIcon: 'maximize',
          showGroupBy: false,
          sortBy: [],
          sortDesc: [],
          hideDefaultHeader: false,
          hideDefaultFooter: false,
          dense: true,
          loadingText: 'Carregando...',
          noDataText: 'Sem dados...',
          noResultsText: 'Sem resultados...',
          externalPagination: false
        },
        headers: [
          {
            text: 'text',
            value: 'value'
          }
        ]
      },
      searchParams: {
        procedure: '',
        text: '',
        value: ''
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            'required',
            'min',
            'max',
            'email',
            'cpf',
            'cnpj',
            'validateNumberInt',
            'validateNumberInt16',
            'validateNumberTinyInt',
            'validatePercentage',
            'validatePercentageWithoutNegative',
            'validateIntegerPositive',
            'validateIntegerNegative',
            'validateNegativeValue',
            'validatePositiveValue',
            'validatePercentageLessThan100',
            'validateTextWithoutSpecialCharacters'
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12 ',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-0 col-12 ',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6 ',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-12',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'itemText',
        styleClasses: 'my-2 col-6 ',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'itemText',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'itemValue',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'itemValue',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDialog',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Dialog'
      },
      {
        type: 'i4proTextField',
        model: 'editIcon',
        styleClasses: 'my-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'editIcon',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'key',
        styleClasses: 'my-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'key',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTable.dataTable',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'attributesTable dataTable'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTable.headers',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'attributesTable headers',
        objectRequired: ['text', 'value']
      },
      {
        type: 'devContainerOfPanel',
        model: 'searchParams',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Search Params'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proTextField: {
    models: {
      type: 'i4proTextField',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      min: 1,
      max: 50,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      format: '',
      formatDecimal: {},
      procedure: {
        name: ''
      },
      actionEvent: '',
      attributesTextField: {
        label: 'TextField',
        clearable: true,
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'actionEvent',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'actionEvent',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'format',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        attributesSelect: {
          label: 'Format',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'decimal',
              value: 'decimal'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          multipleSimpleArray: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            'required',
            'min',
            'max',
            'email',
            'cpf',
            'cnpj',
            'validateNumberInt',
            'validateNumberInt16',
            'validateNumberTinyInt',
            'validatePercentage',
            'validatePercentageWithoutNegative',
            'validateIntegerPositive',
            'validateIntegerNegative',
            'validateNegativeValue',
            'validatePositiveValue',
            'validatePercentageLessThan100',
            'validateTextWithoutSpecialCharacters'
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          multipleSimpleArray: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          multipleSimpleArray: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'formatDecimal',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'formatDecimal',
        visible: true
      }
    ]
  },

  i4proTextarea: {
    models: {
      type: 'i4proTextarea',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      min: 1,
      max: 50,
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesTextField: {
        label: 'Textarea',
        clearable: true,
        dense: true,
        rows: '3'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            'required',
            'min',
            'max',
            'email',
            'cpf',
            'cnpj',
            'validateNumberInt',
            'validateNumberInt16',
            'validateNumberTinyInt',
            'validatePercentage',
            'validatePercentageWithoutNegative',
            'validateIntegerPositive',
            'validateIntegerNegative',
            'validateNegativeValue',
            'validatePositiveValue',
            'validatePercentageLessThan100',
            'validateTextWithoutSpecialCharacters'
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'min',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'min',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'max',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'max',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proTextareaConcat: {
    models: {
      type: 'i4proTextareaConcat',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      rules: [],
      fill: [],
      visible: true,
      readonly: false,
      attributesTextField: {
        label: 'Complemento do Objeto Segurado',
        clearable: true,
        rows: '5',
        counter: 200,
        maxlength: 200
      },
      attributesTitle: {
        visible: true,
        title: 'Texto do objeto completo',
        style: '',
        class: 'mb-2 mt-1 font-weight-light primary--text'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            'required',
            'min',
            'max',
            'email',
            'cpf',
            'cnpj',
            'validateNumberInt',
            'validateNumberInt16',
            'validateNumberTinyInt',
            'validatePercentage',
            'validatePercentageWithoutNegative',
            'validateIntegerPositive',
            'validateIntegerNegative',
            'validateNegativeValue',
            'validatePositiveValue',
            'validatePercentageLessThan100',
            'validateTextWithoutSpecialCharacters'
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        visible: true,
        rules: [],
        fill: [],
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTitle',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes Title'
      }
    ]
  },

  i4proTableDetail: {
    models: {
      type: 'i4proTableDetail',
      model: 'tableDetail',
      fieldName: 'new-tableDetail',
      styleClasses: 'col-12',
      procedure: {
        name: '[dbo].[p_lookup_Details]'
      },
      visible: true,
      readonly: false,
      typeLookup: 'details',
      hasConditions: false,
      rules: [''],
      fill: [],
      filledBy: [],
      items: []
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'my-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      }
    ]
  },

  i4proTimePickerDialog: {
    models: {
      type: 'i4proTimePickerDialog',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      btnShow: true,
      btnFlat: true,
      btnCancelColor: 'primary',
      btnCancelLabel: 'Cancelar',
      btnSaveColor: 'primary',
      btnSaveLabel: 'Salvar',
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesDialog: {
        persistent: true,
        width: '290px'
      },
      attributesTextField: {
        label: 'Time Picker in Dialog',
        prependIcon: 'access_time',
        clearable: true,
        dense: true
      },
      attributesTimePicker: {
        format: '24hr',
        scrollable: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnShow',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'btnShow',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'btnFlat',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-12',
        attributes: {
          label: 'btnFlat',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelColor',
        styleClasses: 'my-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'btnCancelColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnCancelLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'btnCancelLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveColor',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'btnSaveColor',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'btnSaveLabel',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'btnSaveLabel',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDialog',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes Dialog'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTimePicker',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TimePicker'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  i4proTimePickerMenu: {
    models: {
      type: 'i4proTimePickerMenu',
      model: '',
      fieldName: '',
      styleClasses: 'col-12',
      hasConditions: false,
      visible: true,
      readonly: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      attributesMenu: {
        closeOnContentClick: false,
        nudgeRight: 40,
        transition: 'scale-transition',
        offsetY: true,
        maxWidth: '290px',
        minWidth: '290px'
      },
      attributesTextField: {
        label: 'Time Picker in Menu',
        prependIcon: 'access_time',
        clearable: true,
        dense: true
      },
      attributesTimePicker: {
        format: '24hr'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proCombobox',
        model: 'rules',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'Rules',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: ['required']
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proCombobox',
        model: 'fill',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'fill',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proCombobox',
        model: 'filledBy',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        visible: true,
        rules: [],
        fill: [],
        attributesSelect: {
          label: 'filledBy',
          color: 'grey darken-3',
          smallChips: true,
          multiple: true,
          clearable: true,
          chips: true,
          deletableChips: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: []
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesMenu',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Menu'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextField',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TextField'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTimePicker',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes TimePicker'
      },
      {
        type: 'devShowAttributes',
        model: 'attributesInfo',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'attributesInfo',
        labelContainer: 'attributes Info',
        obj: objAttributesInfo
      }
    ]
  },

  //--> Buttons & Actions
  i4proButtonLink: {
    models: {
      type: 'i4proButtonLink',
      model: '',
      id: '',
      name: '',
      styleClasses: 'col-12',
      visible: true,
      hasConditions: false,
      rules: [],
      fill: [],
      filledBy: [],
      typeLookup: 'conditional',
      procedure: {
        name: ''
      },
      tooltip: '',
      tooltipColorClass: '',
      hiddenByPage: false,
      attributesButton: {
        dark: true,
        left: true,
        label: 'Button link',
        class: 'zindex-100',
        small: true,
        fixed: true,
        bottom: true,
        target: '_blank'
      },
      attributesIcon: {
        icon: 'fas fa-file-pdf',
        left: true,
        right: false,
        showIconLeft: true,
        showIconRight: false
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'tooltip',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'tooltip',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'tooltipColorClass',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'tooltipColorClass',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 pt-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 pt-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesButton',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesIcon',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes Icon'
      }
    ]
  },

  i4proFabTransition: {
    models: {
      type: 'i4proFabTransition', // --> Required by dev!
      component: 'i4pro-fab-transition',
      attributes: {
        column: true,
        row: false
      },
      items: [
        {
          id: '',
          name: '',
          actionName: '',
          label: 'Button',
          tooltip: 'Lorem Ipsum',
          tooltipColorClass: 'dark',
          visible: true,
          hiddenByPage: false,
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          params: {
            validate: false
          },
          attributes: {
            color: 'primary'
          },
          attributesIcon: {
            icon: 'add'
          }
        }
      ]
    },
    fields: [
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-actions-attr',
        styleClasses: 'col-12',
        title: 'Items'
      }
    ]
  },

  i4proButton: {
    models: {
      type: 'i4proButton', // --> Required by dev!
      component: 'i4pro-button',
      attributes: {},
      items: [
        {
          id: '',
          name: '',
          actionName: '',
          label: 'Button',
          tooltip: 'Lorem Ipsum',
          tooltipColorClass: 'dark',
          visible: true,
          params: {
            validate: true
          },
          hiddenByPage: false,
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          attributes: {
            color: 'primary',
            class: ''
          },
          attributesIcon: {
            icon: ''
          }
        }
      ]
    },
    fields: [
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-actions-attr',
        styleClasses: 'col-12',
        title: 'Items',
        showPanel: [0]
      }
    ]
  },

  i4proFloatingActionButtons: {
    models: {
      type: 'i4proFloatingActionButtons', // --> Required by dev!
      component: 'i4pro-floating-action-buttons',
      navigation: false,
      attributes: {
        color: 'primary',
        icon: 'drag_indicator',
        direction: 'top',
        fab: false,
        fling: false,
        openOnHover: true,
        tabs: null,
        right: true,
        bottom: true,
        transition: 'slide-y-reverse-transition'
      },
      items: [
        {
          id: '',
          name: '',
          actionName: '',
          label: 'Button',
          visible: true,
          hiddenByPage: false,
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          params: {
            validate: false
          },
          attributes: {
            color: 'primary'
          },
          attributesIcon: {
            icon: 'add'
          }
        }
      ]
    },
    fields: [
      {
        type: 'i4proSwitch',
        model: 'navigation',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'navigation',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-actions-attr',
        styleClasses: 'col-12',
        title: 'Items'
      }
    ]
  },

  //--> Cards
  i4proCard: {
    models: {
      type: 'i4proCard',
      model: '',
      fieldName: '',
      styleClasses: 'col-6',
      visible: true,
      readonly: false,
      typeCard: 'card-vertical',
      attributes: {
        title: 'Titulo do card',
        description: 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet.',
        image: 'static/thumb.jpg',
        borderBottom: true,
        animationDirection: 'right',
        textAlign: 'center'
      },
      actions: {
        items: [
          {
            label: 'Button',
            actionName: '',
            styleClasses: '',
            visible: true,
            hiddenByPage: false,
            params: {
              validate: false
            },
            redirect: {
              page: '',
              mode: '',
              target: ''
            },
            attributes: {
              color: 'primary',
              dark: true
            },
            attributesIcon: {
              icon: ''
            }
          }
        ]
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'attributes.title',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'title',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeCard',
        fieldName: '',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        attributesSelect: {
          label: 'typeCard',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'card-horizontal',
              value: 'card-horizontal'
            },
            {
              text: 'card-vertical',
              value: 'card-vertical'
            },
            {
              text: 'card-hover',
              value: 'card-hover'
            }
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        fill: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devShowAttributes',
        model: 'header',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Info',
        labelSwitch: 'header',
        labelContainer: 'header',
        obj: objHeaderCard
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Attributes'
      },
      {
        type: 'devContainerOfPanel',
        model: 'actions.items',
        component: 'dev-actions-attr',
        styleClasses: 'col-12',
        title: 'Items'
      }
    ]
  },

  //--> Caroulsels
  i4proCarouselImage: {
    models: {
      type: 'i4proCarouselImage',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      attributesCarousels: {
        autoplay: false,
        speed: '2000',
        bullets: false,
        slideMultiple: true,
        visibleSlides: 3,
        touchable: false
      },
      typeLookup: 'gallery',
      procedure: {
        name: ''
      },
      items: [
        {
          image: 'static/acai.png'
        },
        {
          image: 'static/mountain.jpg'
        },
        {
          image: 'static/bg-mountain.jpg'
        },
        {
          image: 'static/acai.png'
        }
      ]
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'conditional',
              value: 'conditional'
            },
            {
              text: 'details',
              value: 'details'
            },
            {
              text: 'gallery',
              value: 'gallery'
            },
            {
              text: 'multiselect',
              value: 'multiselect'
            },
            {
              text: 'normal',
              value: 'normal'
            },
            {
              text: 'simple',
              value: 'simple'
            },
            {
              text: 'table',
              value: 'table'
            }
          ]
        }
      },
      {
        type: 'i4proTextField',

        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'typeLookup',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesCarousels',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Carousels'
      },
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Items',
        objectRequired: ['image']
      }
    ]
  },

  i4proCarousel: {
    models: {
      type: 'i4proCarousel',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      attributesCarousels: {
        height: '350px'
      },
      items: [
        {
          background: 'primary',
          title: 'Slide 1',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent at tempor erat. In id ligula ante. Nullam rutrum odio vitae nulla pretium ultricies ac non justo. In convallis, ipsum vitae volutpat accumsan, eros sapien tristique odio, ut congue nisi magna ac diam. Proin aliquet metus in gravida aliquet. Etiam eu varius arcu.',
          title_class: 'text-h2 mb-6',
          description_class: 'text-body-2'
        },
        {
          background: 'secondary',
          title: 'Slide 2',
          description: 'teste',
          title_class: 'mb-6',
          description_class: 'text-center'
        },
        {
          background: 'yellow darken-2',
          title: 'Slide 3',
          description: 'teste',
          title_class: 'mb-6',
          description_class: 'text-center'
        }
      ]
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'attributesCarousels.height',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'height',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'items',
        component: 'dev-array-objects-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Items',
        objectRequired: ['background', 'title', 'description', 'title_class', 'description_class']
      }
    ]
  },

  //--> list Email
  i4proListEmail: {
    models: {
      type: 'i4proListEmail',
      model: '',
      styleClasses: 'col-12 listVerticalLeft',
      procedure: {
        name: '[vue].[p_cons_email_lookup]'
      },
      typeLookup: 'simple',
      appendIcon: {
        left: true,
        icon: 'email',
        attributesIcon: {
          color: 'orange',
          class: ''
        }
      },
      attributes: {
        class: 'black--text pl-1'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'typeLookup',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'appendIcon',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Append Icon'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes'
      }
    ]
  },

  //--> Titulo
  i4proTitle: {
    models: {
      type: 'i4proTitle',
      model: '',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      attributes: {
        title: {
          tag: 'h1',
          text: 'Título!',
          class: 'text-h1 font-weight-thin my-2 red--text text-center',
          style: '',
          appendIcon: {
            right: false,
            icon: 'access_time',
            attributesIcon: {
              color: 'orange',
              class: 'mr-5',
              size: 70
            }
          }
        }
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes.title',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'Title'
      }
    ]
  },

  //--> Titulo Descrição
  i4proTitleDescription: {
    models: {
      type: "i4proTitleDescription",
      model: "titulo",
      fieldName: "new-i4proTitleDescription",
      styleClasses: "col-6",
      visible: true,
      readonly: false,
      typeLookup: "list",
      procedure: {
        name: ""
      },
      attributesTitle: {
        class: "border-bottom-1-primary text-h1 text-h4 red--text font-weight-regular",
        visible: true
      },
      attributesSubTitle: {
        class: "text-subtitle-1 text-h4 font-italic font-weight-light",
        visible: true
      },
      attributesDescription: {
        class: "font-weight-light",
        visible: true
      },
      attributes: {
        textCenter: true,
        items: [{
          title: "teste title",
          sub_title: "subTitle",
          description: "teste teste teste, teste teste teste, teste teste teste, teste teste teste"
        },
        {
          title: "teste title",
          sub_title: "subTitle",
          description: "teste teste teste, teste teste teste, teste teste teste, teste teste teste"
        }]
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSelect',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'typeLookup',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'List',
              value: 'list'
            }
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'attributes.textCenter',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'textCenter',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTitle',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Title '
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesSubTitle',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes SubTitle '
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesDescription',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Description '
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes.items',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Items',
        objectRequired: ['title', 'sub_title', 'description']
      },
    ]
  },

  //--> AcceptTerms
  i4proAcceptTerms: {
    models: {
      type: 'i4proAcceptTerms',
      model: '',
      styleClasses: 'col-12 border-2-blue',
      enabledfield: 'id_checkbox',
      textVisibleHeight: 300,
      hasConditions: true,
      visible: true,
      rules: [],
      fill: [],
      attributesTextarea: {
        class: 'red--text',
        dense: true
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'enabledfield',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'enabledfield',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'textVisibleHeight',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'textVisibleHeight',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTextarea',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Textarea'
      }
    ]
  },

  //--> Graficos
  i4proGraphicChartjs: {
    models: {
      type: 'i4proGraphicChartjs',
      model: '',
      styleClasses: 'col-12',
      hasConditions: false,
      rules: [''],
      fill: [],
      filledBy: [],
      visible: true,
      readonly: false,
      graphic: {
        type: 'pie',
        ref: 'chartDoughnutPie',
        data: {
          labels: ['Africa', 'Asia', 'Europe', 'Latin America', 'North America 3'],
          datasets: [
            {
              label: 'Population (millions)',
              backgroundColor: ['#3e95cd', '#8e5ea2', '#3cba9f', '#e8c3b9', '#c45850'],
              data: [2478, 5267, 734, 784, 433]
            }
          ]
        },
        options: {
          title: {
            display: true,
            text: 'Gráfico'
          }
        }
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      }
    ]
  },

  i4proFlexmonster: {
    models: {
      type: 'i4proFlexmonster',
      model: 'pivot_flex',
      fieldName: 'new-pivot_flex',
      styleClasses: 'col-12',
      visible: true,
      readonly: false,
      attributes: {
        toolbar: true,
        theme: 'lightblue',
        height: 500,
        width: '100%'
      }
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'my-0 py-0 col-lg-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes'
      }
    ]
  },

  i4proRenderHtml: {
    models: {
      type: 'i4proRenderHtml',
      model: 'id_html',
      visible: true,
      readonly: false,
      styleClasses: 'col-12'
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'my-2 col-lg-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      }
    ]
  },

  i4proRenderMarkdown: {
    models: {
      type: 'i4proRenderMarkdown',
      model: 'id_markdown',
      visible: true,
      readonly: false,
      styleClasses: 'col-12'
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readonly',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'Readonly',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'my-2 col-lg-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      }
    ]
  },

  //--> Table
  i4proTableGenerator: {
    models: {
      type: 'i4proTableGenerator',
      model: '',
      hasConditions: false,
      typeLookup: 'table',
      fill: [],
      filledBy: [],
      visible: true,
      styleClasses: 'col-12',
      procedure: {
        name: 'vue.p_return_table_static'
      },
      attributesTable: {
        showSearch: false,
        dataTable: {
          itemKey: 'nm_login',
          itemsPerPage: 5,
          class: 'elevation-1',
          disablePagination: true,
          hideDefaultFooter: true,
          hideDefaultHeader: true,
          disableSort: true
        }
      },
      headers: [],
      itemsTable: []
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'model',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'model',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'hasConditions',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'hasConditions',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'procedure.name',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'mb-2 col-12',
        attributesTextField: {
          label: 'Procedure',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'typeLookup',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        visible: true,
        attributesTextField: {
          label: 'typeLookup',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-2 col-6',
        hasConditions: false,
        rules: [],
        fill: [],
        visible: true,
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'attributesTable.dataTable',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'AttributesTable ShowSearch',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributesTable',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'mt-2 col-12',
        title: 'Attributes Table'
      }
    ]
  },

  //--> Partials
  i4proColumnGroup: {
    models: {
      type: 'i4proColumnGroup',
      id: '',
      model: '',
      name: '',
      styleClasses: 'col-12',
      fixed: false,
      header: true,
      visible: true,
      flat: false,
      expand: true,
      attributes: {
        focusable: true
      },
      fields: []
    },
    fields: [
      {
        type: 'i4proTextField',
        model: 'name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'name',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proTextField',
        model: 'styleClasses',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'styleClasses',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'fixed',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'fixed',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'header',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'header',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'flat',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'flat',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'expand',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'expand',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'attributes.focusable',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'focusable',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      }
    ]
  },

  // --> Master
  i4proDetailPage: {
    models: {
      type: 'i4proDetailPage',
      name: 'Detail Page',
      visible: true,
      navigation: false,
      readonlyExtendTabs: true,
      actions: [
        {
          id: '',
          name: '',
          actionName: '',
          label: 'Button',
          tooltip: 'Lorem Ipsum',
          visible: true,
          params: {
            validate: false
          },
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          attributes: {
            color: 'primary'
          },
          attributesIcon: {
            icon: 'home'
          }
        }
      ],
      headers: [
        {
          text: 'Header 1',
          value: 'value',
          type: 'string',
          styleClasses: 'col-6'
        }
      ],
      fields: [],
      tabConditions: []
    },
    fields: [
      {
        type: 'i4proSelect',
        model: 'type',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: false,
        attributesSelect: {
          label: 'type',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'i4proDetailDrawer',
              value: 'i4proDetailDrawer'
            },
            {
              text: 'i4proDetailPage',
              value: 'i4proDetailPage'
            }
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'name',
        styleClasses: 'mb-0 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'name',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'navigation',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'navigation',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readOnlyExtendTabs',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'readOnlyExtendTabs',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'actions',
        component: 'dev-actions-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Actions'
      },
      {
        type: 'devContainerOfPanel',
        model: 'headers',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Headers',
        objectRequired: ['text', 'value', 'type', 'styleClasses']
      },
      {
        type: 'devContainerOfPanel',
        model: 'tabConditions',
        component: 'dev-tab-conditions',
        styleClasses: 'col-12',
        title: 'tabConditions'
      }
    ]
  },

  i4proDetailDrawer: {
    models: {
      type: 'i4proDetailDrawer',
      name: 'Detail Drawer',
      visible: true,
      navigation: false,
      readonlyExtendTabs: true,
      actions: [
        {
          id: '',
          name: '',
          actionName: '',
          label: 'Button',
          tooltip: 'Lorem Ipsum',
          visible: true,
          params: {
            validate: false
          },
          redirect: {
            page: '',
            mode: '',
            target: ''
          },
          attributes: {
            color: 'primary'
          },
          attributesIcon: {
            icon: 'home'
          }
        }
      ],
      headers: [
        {
          text: 'Header 1',
          value: 'value',
          type: 'string',
          styleClasses: 'col-6'
        }
      ],
      fields: [],
      tabConditions: []
    },
    fields: [
      {
        type: 'i4proSelect',
        model: 'type',
        styleClasses: 'mb-2 col-12',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        attributesSelect: {
          label: 'type',
          color: 'grey darken-3',
          clearable: true,
          dense: true,
          hideDetails: true,
          appendIcon: 'zmdi zmdi-chevron-down',
          items: [
            {
              text: 'i4proDetailDrawer',
              value: 'i4proDetailDrawer'
            },
            {
              text: 'i4proDetailPage',
              value: 'i4proDetailPage'
            }
          ]
        }
      },
      {
        type: 'i4proTextField',
        model: 'name',
        styleClasses: 'mb-2 col-12',
        hasConditions: false,
        rules: [],
        attributesTextField: {
          label: 'name',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'visible',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'visible',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'navigation',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'navigation',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'i4proSwitch',
        model: 'readOnlyExtendTabs',
        rules: [],
        fill: [],
        hasConditions: false,
        visible: true,
        styleClasses: 'my-0 py-0 col-6',
        attributes: {
          label: 'readOnlyExtendTabs',
          color: 'grey darken-3',
          dense: true,
          hideDetails: true
        }
      },
      {
        type: 'devContainerOfPanel',
        model: 'actions',
        component: 'dev-actions-attr',
        styleClasses: 'mt-2 col-12',
        title: 'Actions'
      },
      {
        type: 'devContainerOfPanel',
        model: 'headers',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'Headers',
        objectRequired: ['text', 'value', 'type', 'styleClasses']
      },
      {
        type: 'devContainerOfPanel',
        model: 'tabConditions',
        component: 'dev-tab-conditions',
        styleClasses: 'col-12',
        title: 'tabConditions'
      }
    ]
  },

  // --> Tabs
  i4proTabs: {
    models: {
      type: 'i4proTabs',
      model: '',
      attributes: {
        vTabs: {
          sliderColor: 'primary'
        },
        vTabItems: {
          activeClass: 'v-item--active',
          mandatory: true
        }
      },
      headers: [
        {
          id: 1,
          title: 'Tab 1',
          tabName: '',
          icon: '',
          readonly: false,
          show: true,
          attributes: {
            exact: true,
            ripple: true
          }
        },
        {
          id: 2,
          title: 'Tab 2',
          tabName: '',
          icon: '',
          readonly: false,
          show: true,
          attributes: {
            exact: true,
            ripple: true
          }
        }
      ],
      content: {
        '1': {
          procedure: {
            name: 'rur.p_cons_dados_cotacao_f'
          },
          id: 1,
          disabled: false,
          cardBackgroundColor: '',
          reverseOrder: true,
          fields: [],
          groups: [],
          conditions: [
            {
              fields: [],
              hide: {
                actions: [],
                fields: []
              }
            }
          ],
          actions: {}
        },
        '2': {
          procedure: {
            name: 'rur.p_cons_dados_cotacao_f'
          },
          id: 2,
          disabled: false,
          cardBackgroundColor: '',
          reverseOrder: false,
          fields: [],
          groups: [],
          conditions: [
            {
              fields: [],
              hide: {
                actions: [],
                fields: []
              }
            }
          ],
          actions: {}
        }
      }
    },
    fields: [
      {
        type: 'devContainerOfPanel',
        model: 'attributes.vTabs',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12 pt-0',
        title: 'Attributes vTabs'
      },
      {
        type: 'devContainerOfPanel',
        model: 'attributes.vTabItems',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Attributes vTabItems'
      },
      {
        type: 'devContainerOfPanel',
        model: 'headers',
        component: 'dev-array-objects-attr',
        styleClasses: 'col-12',
        title: 'headers',
        objectRequired: ['id', 'title', 'tabName', 'icon', { show: true }, { readonly: false }, 'attributes'],
        hideAttrActions: ['id'],
        paramsVuetify: 'attributes',
        tabHeaders: true
      },
      {
        type: 'devTabContent',
        model: 'content',
        component: 'dev-attr-crud-vuetify',
        styleClasses: 'col-12',
        title: 'Content'
      }
    ]
  }
};
